import {
  canManageDealer,
  canCreateDealer,
  canManageNetwork,
  hasNoAuthority,
} from 'app/dealer/utils';

import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    authorities: [],
    error: null,
    pending: false,
    roles: {
      canManageDealer: false,
      canCreateDealer: false,
      canManageNetwork: false,
      hasNoAuthority: true,
    },
  };
};

export function authorities(state = defaultState(), action) {
  const { error, payload, type } = action;

  if (type === ActionTypes.FETCH_AUTHORITIES_PENDING) {
    return {
      ...state,
      pending: true,
    };
  }

  if (type === ActionTypes.FETCH_AUTHORITIES_SUCCESS) {
    const { groupAuthorities } = payload;

    return {
      ...state,
      authorities: groupAuthorities,
      error: null,
      pending: false,
      roles: {
        canCreateDealer: canCreateDealer(groupAuthorities),
        canManageDealer: canManageDealer(groupAuthorities),
        canManageNetwork: canManageNetwork(groupAuthorities),
        hasNoAuthority: hasNoAuthority(groupAuthorities),
      },
    };
  }

  if (type === ActionTypes.FETCH_AUTHORITIES_FAILURE) {
    return {
      ...state,
      error,
      pending: false,
    };
  }

  if (type === ActionTypes.RESET_AUTHORITIES) {
    return defaultState();
  }

  return state;
}
